import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
  createApiThunkPublic,
} from "../_helpers/ApiThunk";

const initialState = {
  getReviewListData: {},
  getOrderListData: {},
  getOrderInfoData: {},
  updateOrderStatusData: {},
  getProductInfoData: {},
  orderCancelData: {},
  getDeliveryStaffForOrderData: {},
  assignOrderData: {},
  getOrderCancellationListData: {},
  getOrderReturnListData: {},
  getActiveLogsData: {},
  getCustomOrderListData: {},
  updateCustomOrderStatusData: {},
  getProductCustomizationData: {},
  getSellerStorePayOutData: {},
};

export const getReviewList = createApiThunkPrivate(
  "getReviewList",
  "/review/getList",
  "GET",
  true
);
export const getOrderList = createApiThunkPrivate(
  "getOrderList",
  "/order/orders-list",
  "GET",
  true
);
export const getOrderInfo = createApiThunkPrivate(
  "getOrderInfo",
  "/order/order-info",
  "GET",
  true
);
export const updateOrderStatus = createApiThunkPrivate(
  "updateOrderStatus",
  "/order/update-order-status-by-store",
  "POST"
);
export const orderCancel = createApiThunkPrivate(
  "orderCancel",
  "/order/order-cancellation",
  "POST"
);
export const getDeliveryStaffForOrder = createApiThunkPrivate(
  "getDeliveryStaffForOrder",
  "/deliveryStaff/get-delivery-staffs-for-order-delivery",
  "GET",
  true
);
export const assignOrder = createApiThunkPrivate(
  "assignOrder",
  "/staffOrderAssignment/assignOrder",
  "POST"
);
export const deleteProductReview = createApiThunkPrivate(
  "deleteProductReview",
  "/review/softDelete",
  "DELETE"
);

export const getCustomOrderList = createApiThunkPrivate(
  "getCustomOrderList",
  "/product-customization/custom-order-list",
  "GET",
  true
);
export const getCustomOrderListInfo = createApiThunkPrivate(
  "getCustomOrderListInfo",
  "/product-customization/custom-order-info",
  "GET",
  true
);
export const updateCustomOrderStatus = createApiThunkPrivate(
  "updateCustomOrderStatus",
  "/product-customization/update-custom-order-status",
  "POST"
);
export const updateCustomOrderDeliveryStatus = createApiThunkPrivate(
  "updateCustomOrderDeliveryStatus",
  "/delivery/custom-order-delivery-status",
  "POST"
);

export const getProductInfo = createApiThunkPrivate(
  "getProductInfo",
  "/product/getProductInfo",
  "GET",
  true
);
export const getOrderCancellationList = createApiThunkPrivate(
  "getOrderCancellationList",
  "/order/cancellation-list",
  "GET",
  true
);
export const getOrderReturnList = createApiThunkPrivate(
  "getOrderReturnList",
  "/order/return-list",
  "GET",
  true
);
export const orderDetailsById = createApiThunkPrivate(
  "orderDetailsById",
  "/order/order-details-by-id",
  "POST"
);
export const acceptReturnRequest = createApiThunkPrivate(
  "acceptReturnRequest",
  "/order/accept-return-request",
  "POST"
);

export const getActiveLogs = createApiThunkPrivate(
  "getActiveLogs",
  "/cart/activity-logs",
  "GET",
  true
);

export const getProductCustomization = createApiThunkPrivate(
  "getProductCustomization",
  "/product-customization/requirements-list",
  "GET",
  true
);
export const acceptDesignerRequest = createApiThunkPrivate(
  "acceptDesignerRequest",
  "/product-customization/designer-accept-request",
  "POST"
);
export const rejectDesignerRequest = createApiThunkPrivate(
  "rejectDesignerRequest",
  "/product-customization/designer-reject-request",
  "POST"
);
export const detailsOfDesigner = createApiThunkPrivate(
  "detailsOfDesigner",
  "/product-customization/view-customization-details",
  "POST"
);
export const followUser = createApiThunkPrivate(
  "followUser",
  "/product-customization/follow-user",
  "POST"
);
export const designerChatListData = createApiThunkPrivate(
  "designerChatListData",
  "/follower/chat-list",
  "POST"
);

export const getSellerStorePayOut = createApiThunkPrivate(
  "getSellerStorePayOut",
  "/seller-store/store-payout-list",
  "GET",
  true
);
export const sellerStorePayOutDetails = createApiThunkPrivate(
  "sellerStorePayOutDetails",
  "/seller-store/view-payout-details",
  "POST"
);

export const getCostsForCalculation = createApiThunkPrivate(
  "getCostsForCalculation",
  "/expense/costs",
  "GET"
);

export const resolveOrderNavigation = createApiThunkPublic(
  "resolveOrderNavigation",
  "/order/resolve-order-navigation",
  "POST",
);

export const handleOrderCancellationRequest = createApiThunkPrivate(
  "handleOrderCancellationRequest",
  "/order/cancellation-action",
  "POST"
);

export const handleOrderReturnRequest = createApiThunkPrivate(
  "handleOrderReturnRequest",
  "/order/return-action",
  "POST"
);

export const handleOrderReturnMaterialReceived = createApiThunkPrivate(
  "handleOrderReturnMaterialReceived",
  "/order/mark-return-received",
  "POST"
);

export const handleCustomOrderReturnRequest = createApiThunkPrivate(
  "handleCustomOrderReturnRequest",
  "/product-customization/return-action",
  "POST"
);

export const handleCustomOrderReturnMaterialReceived = createApiThunkPrivate(
  "handleCustomOrderReturnMaterialReceived",
  "/product-customization/mark-return-received",
  "POST"
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(builder, getReviewList, "getReviewListData");
    createExtraReducersForThunk(builder, getOrderList, "getOrderListData");
    createExtraReducersForThunk(builder, getOrderInfo, "getOrderInfoData");
    createExtraReducersForThunk(
      builder,
      updateOrderStatus,
      "updateOrderStatusData"
    );
    createExtraReducersForThunk(
      builder,
      updateCustomOrderStatus,
      "updateCustomOrderStatusData"
    );
    createExtraReducersForThunk(builder, orderCancel, "orderCancelData");
    createExtraReducersForThunk(
      builder,
      getDeliveryStaffForOrder,
      "getDeliveryStaffForOrderData"
    );
    createExtraReducersForThunk(builder, assignOrder, "assignOrderData");
    createExtraReducersForThunk(builder, getProductInfo, "getProductInfoData");
    createExtraReducersForThunk(
      builder,
      getOrderCancellationList,
      "getOrderCancellationListData"
    );
    createExtraReducersForThunk(
      builder,
      getOrderReturnList,
      "getOrderReturnListData"
    );
    createExtraReducersForThunk(builder, getActiveLogs, "getActiveLogsData");
    createExtraReducersForThunk(
      builder,
      getCustomOrderList,
      "getCustomOrderListData"
    );
    createExtraReducersForThunk(
      builder,
      getProductCustomization,
      "getProductCustomizationData"
    );
    createExtraReducersForThunk(
      builder,
      getSellerStorePayOut,
      "getSellerStorePayOutData"
    );
  },
});

export default orderSlice.reducer;
